import React, { createContext, useMemo, useState } from 'react';
export type TUnitsContextProvider = {
  children: JSX.Element | JSX.Element[];
};

export type TUnitsContext = {
  unitsData: any;
  setUnitsData: React.Dispatch<React.SetStateAction<any>>;
  individualunitsData: any;
  setIndividualunitsData: React.Dispatch<React.SetStateAction<any>>;
};

export const UnitsContext = createContext<TUnitsContext | null>(null);
export const UnitsContextProvider = ({ children }: TUnitsContextProvider) => {
  const [unitsData, setUnitsData] = useState(null);
  const [individualunitsData, setIndividualunitsData] = useState(null);
  const providerValue = useMemo(
    () => ({
      unitsData,
      setUnitsData,
      individualunitsData,
      setIndividualunitsData,
    }),
    [unitsData, individualunitsData],
  );
  return <UnitsContext.Provider value={providerValue}>{children}</UnitsContext.Provider>;
};
